import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = { class: "flex items-center justify-center mr-2" }
const _hoisted_3 = { class: "flex flex-col justify-center w-full" }
const _hoisted_4 = { class: "font-sourcesanspro-semibold text-sm text-white/50" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = { class: "mr-1" }
const _hoisted_7 = { class: "font-sourcesanspro-semibolditalic text-m2" }
const _hoisted_8 = { class: "flex items-center font-sourcesanspro-semibold text-lg24" }
const _hoisted_9 = {
  class: "ion-padding border-t border-t-white/10 font-sourcesanspro-regular text-base2 font-color-text-50",
  slot: "content"
}
const _hoisted_10 = { class: "flex flex-col mb-4" }
const _hoisted_11 = { class: "form-group mb-2" }
const _hoisted_12 = { for: "name" }
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { for: "email" }
const _hoisted_16 = ["placeholder"]

import { ref, computed } from 'vue';
import { chevronDownOutline, chevronForwardOutline, ticketOutline, checkmarkOutline } from 'ionicons/icons';

import { useI18n } from 'vue-i18n';

// Props and Emits

export default /*@__PURE__*/_defineComponent({
  __name: 'EventsGuestMembers',
  props: {
	cartItem: {
		type: Object,
		required: true,
	},
},
  emits: ['prefillTickets', 'validationChanged'],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;
const { t } = useI18n();
const isOpen = ref(true); // Open by default

// Local state for name and email
const localName = ref(props.cartItem.additionalInfo?.name || t('events.guest_members.guest'));
const localEmail = ref(props.cartItem.additionalInfo?.email || '');

// Validation for the form fields
const isFormValid = computed(() => {
	return localName.value.trim() !== '' && /\S+@\S+\.\S+/.test(localEmail.value);
});

// Emit updated values to the parent component
const updateAllTickets = () => {
	emit('prefillTickets', { name: localName.value, email: localEmail.value });
	emit('validationChanged', isFormValid.value);
};

return (_ctx: any,_cache: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_accordion = _resolveComponent("ion-accordion")!
  const _component_ion_accordion_group = _resolveComponent("ion-accordion-group")!

  return (_openBlock(), _createBlock(_component_ion_accordion_group, { value: "first" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_accordion, {
        class: "mb-4 items-start justify-between backdrop-blur-3xl bg-[#3f3e4a] rounded-lg",
        value: "first"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "flex w-full justify-between h-[70px] px-4 py-2 cursor-pointer",
            slot: "header",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = !isOpen.value))
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_ion_icon, {
                  class: _normalizeClass([!isFormValid.value ? 'text-white' : 'text-anykrowd-ticket-check-green', "w-[22px] h-[22px] py-2 rounded-full"]),
                  icon: !isFormValid.value ? _unref(ticketOutline) : _unref(checkmarkOutline)
                }, null, 8, ["class", "icon"])
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('events.guest_members.details')), 1),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(localName.value || _ctx.$t('events.guest_members.guest')) + " - " + _toDisplayString(localEmail.value || _ctx.$t('events.guest_members.email_not_set')), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_ion_icon, {
                icon: isOpen.value ? _unref(chevronDownOutline) : _unref(chevronForwardOutline),
                class: "text-white"
              }, null, 8, ["icon"])
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('events.guest_members.name_label')), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "name",
                  type: "text",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((localName).value = $event)),
                  placeholder: _ctx.$t('events.guest_members.name_placeholder'),
                  class: "input-field",
                  onInput: updateAllTickets
                }, null, 40, _hoisted_13), [
                  [_vModelText, localName.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('events.guest_members.email_label')), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "email",
                  type: "email",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((localEmail).value = $event)),
                  placeholder: _ctx.$t('events.guest_members.email_placeholder'),
                  class: "input-field",
                  onInput: updateAllTickets
                }, null, 40, _hoisted_16), [
                  [_vModelText, localEmail.value]
                ])
              ])
            ])
          ], 512), [
            [_vShow, isOpen.value]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})